import React from "react";
import { MODALITY_META } from "@/lib/api";
import GameSection from "@/components/GameSection";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";
import { Smartphone, Monitor, Gamepad2 } from "lucide-react";

const ICON_MAP = {
  mobile: Smartphone,
  pc: Monitor,
  consola: Gamepad2,
};

export default function ModalityPage({ modalityKey }) {
  const meta = MODALITY_META[modalityKey];
  const Icon = ICON_MAP[modalityKey];

  return (
    <div data-testid={`modality-${modalityKey}`} className="bg-grain">
      {/* HERO */}
      <section className="relative overflow-hidden border-b border-white/10">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${meta.image})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black" />

        <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#00F0FF] mb-5">
              <Icon className="h-4 w-4" strokeWidth={1.5} />
              Modalidade
            </div>
            <h1 className="font-display text-6xl sm:text-7xl md:text-8xl uppercase tracking-wider leading-none">
              {meta.title}
            </h1>
            <p className="mt-4 text-base sm:text-lg text-white/70">
              {meta.subtitle}
            </p>
          </motion.div>
        </div>
      </section>

      {/* GAMES */}
      <main className="mx-auto max-w-7xl px-5 sm:px-8 py-16 md:py-20">
        <div className="flex flex-col gap-16">
          {meta.games.map((g) => (
            <GameSection key={g} gameKey={g} />
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
